module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ed-Fb-Ga.6b61b498.png";